// extracted by mini-css-extract-plugin
export default {"backButton":"styles_backButton__1mROq","title":"styles_title__luZrt"};